<template>
    <v-snackbar v-model="show" :timeout="-1" :transition="false" :class="animate ? 'animate__animated animate__shakeX animate__infinite' : undefined" style="z-index: 1500">
        {{$store.state.snackBar.text}}

        <template v-slot:action="{ attrs }">
            <v-btn
                :color="$store.state.snackBar.color"
                text
                v-bind="attrs"
                class="zoezi-button-thin"
                @click="$store.state.snackBar.show = false"
            >
                Stäng
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
export default {
    name: 'zoezi-snackbar',

    watch: {
        '$store.state.snackBar.show': {
            handler: function(show) {
                this.showSnackBar(show)
            },
            immediate: true
        },
        show(show) {
            if (!show) {
                this.$store.state.snackBar.show = false;
            }
        }
    },

    data: () => ({
        show: false,
        animate: false,
        timeout: null
    }),
    methods: {
        showSnackBar(show) {
            this.show = !!show;
            if (show) {
                this.animate = true;
                if (this.timeout) {
                    clearTimeout(this.timeout);
                }
                this.timeout = setTimeout(() => {
                    this.animate = false;
                    this.timeout = null;
                }, 1000)
            }
        }
    }
}
</script>
